module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-800.53040d9.eot";